import { createFileRoute } from "@tanstack/react-router";
import { ClientsPage } from "../../../../pages/clients-page/clients-page";

export const Route = createFileRoute("/_auth/_frame/clients/")({
  component: ClientsPage,
});
